import AntHistogram from "../../../modules/Charts/Ant/AntHistogram";
import {computeLogReturns} from "../../../utils/math";
import {Row, Col, Card} from 'antd';
import Explainer from "../../../components/Explainer";


const ReturnsDistributions = ({items, itemColors})=>{

    return (
        <Row gutter={[0, 0]} className={'pr-8'}>
            {items.map((item, idx)=>{
                return (
                    <Col xs={24} xl={12} className={'border-r border-b border-gray-200'}>
                        <Card bordered={false} title={<Explainer title={item.label}/>} style={{height: 500}}>
                            <div style={{height: 400}}>
                                <AntHistogram data={computeLogReturns(item.chart.map(x=>x[1]))} color={itemColors[item.id]} />
                            </div>
                        </Card>

                    </Col>
                )
            })}
        </Row>
    )
}

export default ReturnsDistributions;